import React from 'react'
import { Link } from 'react-router-dom'

function Register() {
  return (
    <div>
    <section className="section">
        <div className="container-fluid">
            <div className="row justify-content-center">
                <div className="col-lg-7">
                    <div className="login_register_box">
                        <div className="image">
                            <img src="/tm/react/toolways/assets/images/register.jpg" className="image-fit" alt="img"/>
                        </div>
                        <div className="box_inner">
                            <h3 className="title">Sign Up to your account</h3>
                            <form action="#" method="POST">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label>Username</label>
                                            <input type="text" name="#" className="form-control form-control-custom" placeholder="Username" defaultValue="Username" autoComplete="off" required/>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label>Email I'd</label>
                                            <input type="email" name="#" className="form-control form-control-custom" placeholder="Email I'd" defaultValue="example@example.com" autoComplete="off" required/>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label>Password <Link to="#" className="thm-color-one">Forgot Password?</Link></label>
                                            <input type="password" name="#" className="form-control form-control-custom" id="password_value" placeholder="password" defaultValue="password" autoComplete="off" required/>
                                            <button id="password_eye" className="fal fa-eye" type="button">
                                                <span></span>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <div className="custom-control custom-radio mr-sm-2">
                                                <input type="radio" className="custom-control-input" id="radioValidation"/>
                                                <label className="custom-control-label" htmlFor="radioValidation">Keep me logged in</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <button type="submit" className="thm-btn btn-rectangle thm-bg-color-one w-100">Sign Up</button>
                                        <p className="mt-3 mb-0 text-center fw-500">Already have an account? <Link to="/login" className="thm-color-one">Login</Link></p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default Register